import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=47dd6b8a&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47dd6b8a')) {
      api.createRecord('47dd6b8a', component.options)
    } else {
      api.reload('47dd6b8a', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=47dd6b8a&", function () {
      api.rerender('47dd6b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JdO0dcqRaHBS/JS/imageCarousel.vue"
export default component.exports